import { NavLink } from "react-router-dom";

/** Icône Lucide square-arrow-out-up-right, à droite du libellé */
const OrgTrailingIcon = ({ className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`shrink-0 ${className}`}
    aria-hidden
  >
    <path d="M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6" />
    <path d="m21 3-9 9" />
    <path d="M15 3h6v6" />
  </svg>
);

/** Lien vers les paramètres organisation (hors onglets entreprise). */
const OrganizationSettingsNavLink = () => (
  <NavLink
    to="/organization/settings"
    className={({ isActive }) =>
      [
        "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg px-4 py-2 text-sm font-medium no-underline transition-colors",
        isActive
          ? "bg-gray-100 text-gray-900"
          : "text-gray-500 hover:text-gray-800",
      ].join(" ")
    }
  >
    <span>Organisation</span>
    <OrgTrailingIcon />
  </NavLink>
);

export default OrganizationSettingsNavLink;
